import React from "react";
import "./features.css";

const Features = () => {
  return (
    <>
      <div className="container mt-4">
        <div className="feature-heading">
          <p className="feature-headlines">
            We translate your vision into Salesforce solutions.
          </p>
          <p className="feature-headline-description">
            Benefit from our years of experience from a variety of complex and
            challenging Salesforce Cross-Cloud projects. We work with you to
            develop an optimal solution, taking into account your existing IT
            infrastructure, and stand by your side as an experienced partner.
          </p>
        </div>

        <div className="row">
          <div className="col-md-4 mt-3">
            <div className="feature-card">
              <p>Analysis & Design</p>
              <p>
                Our experts make your Salesforce vision tangible with a solution
                approach tailored to your company
              </p>
            </div>
          </div>
          <div className="col-md-4 mt-3">
            <div className="feature-card">
              <p>Implementation</p>
              <p>
                Our core competence. Expert, professional implementation of your
                Salesforce project based on years of experience.
              </p>
            </div>
          </div>

          <div className="col-md-4 mt-3">
            <div className="feature-card">
              <p>Enablement</p>
              <p>
                We ensure that Salesforce solutions resonate with the team,
                enabling your company to achieve maximum added value.
              </p>
            </div>
          </div>
        </div>

        {/* <div className="specialize-heading mt-5">
          <p className="feature-headlines">
            We are specialized in Multi Cloud projects with Salesforce
          </p>

          <div className="row mt-4">
            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">Marketing Cloud</p>
              <p className="feature-cloud-description">
                The right marketing message at the right time via the right
                channel – the Marketing Cloud enables professional multi-channel
                marketing at the highest level.
              </p>
            </div>
            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">Sales Cloud</p>
              <p className="feature-cloud-description">
                The Sales Cloud is the world’s leading CRM application for a
                reason. It enables your sales force to achieve significant
                efficiency gains – regardless of size or industry
              </p>
            </div>
            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">Service Cloud</p>
              <p className="feature-cloud-description">
                Effective customer service on any channel – via email, social,
                on the phone or even Whatsapp – the Service Cloud increases
                customer satisfaction, reduces costs and can transform your
                service center into a profit center.
              </p>
            </div>

            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">Experience Cloud</p>
              <p className="feature-cloud-description">
                Personalize your website in real time. Formerly known as
                Interaction Studio, MC Personalization enables you to address
                your customers individually across channels – whether you
                already know them or still want to get to know them.
              </p>
            </div>

            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">
                Marketing Cloud Personalization
              </p>
              <p className="feature-cloud-description">
                The focus is on the digital customer experience of your
                customers. Whether website, customer or partner portal – the
                Experience Cloud allows seamless design and data integration.
              </p>
            </div>

            <div className="col-md-6 mt-4">
              <p className="feature-cloud-heading">
                Marketing Cloud Intelligence
              </p>
              <p className="feature-cloud-description">
                Your marketing data like you’ve never seen it before. Formerly
                known as Datorama, Marketing Cloud Intelligence lets them make
                data-driven marketing decisions from a central dashboard.
              </p>
            </div>

            <div className="col-md-6">
              <p className="feature-cloud-heading">Salesforce Data Cloud</p>
              <p className="feature-cloud-description">
                With the end of the cookie age and the steady growth of walled
                garden advertising providers, it’s never been more important to
                have your data under control. With Salesforce Data Cloud
                (formerly Salesforce CDP), your marketing team has access to all
                your customer data – whether it’s to design campaigns, drive
                content, or perform marketing analytics.
              </p>
            </div>

            <div className="col-md-6">
              <p className="feature-cloud-heading">
                Marketing Cloud Account Engagement
              </p>
              <p className="feature-cloud-description">
                If your B2B sales team does intensive lead management, Marketing
                Cloud Account Engagement (formerly Pardot) is the solution for
                you. Directly from the Sales Cloud, you can run lead nurturing
                and management in a snap.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Features;
